import styled from 'styled-components';
import { AlertDot } from '@yoweb/ui/components/indicators/AlertDot';
export var NavIconActivityDotContainer = styled.div.withConfig({
  componentId: "sc-1uk3k2v-0"
})(["position:relative;"]);
export var NavIconActivityDot = styled(AlertDot).withConfig({
  componentId: "sc-1uk3k2v-1"
})(["&&{position:absolute;top:-3px;right:-3px;z-index:100;}"]);